var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: _vm.updateExists,
      callback: function callback($$v) {
        _vm.updateExists = $$v;
      },
      expression: "updateExists"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("New version available!")]), _c('v-card-text', [_vm._v("Click on refresh button to get the new version.")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.reloadApp();
      }
    }
  }, [_vm._v("Refresh")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }